<div class="gpd-full-page project-hub-page">
  <div class="side-panel">
    <div class="board-section">
      <div class="gpd-container-header">
        <h3 class="gpd-container-title" i18n="@@boards">Boards</h3>
        <app-gpd-button
          type="text"
          icon="add"
          i18n-text="@@createBoard"
          text="Create a board"
          (onClick)="onCreateBoardClick()"
        ></app-gpd-button>
      </div>
      <div class="board-list">
        <ng-container *ngFor="let board of boardList">
          <div
            class="board gpd-selectable"
            [routerLink]="board.id"
            routerLinkActive="active"
          >
            <div class="board-answers">
              <app-svg-icon
                icon="comment"
                [size]="24"
                [strokeWidth]="1.5"
                class="board-answer-icon"
              ></app-svg-icon>
              <span class="board-answer-count" *ngIf="(newSparksMap)[board.id] > 0">
                + {{ (newSparksMap)[board.id] }}
              </span>
            </div>
            <div class="board-name"
                 [title]="$safeNavigationMigration(board?.name)"
                 style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
            >
              {{ board?.name }}
            </div>
            <div class="board-actions">
              <i
                class="dx-icon-overflow board-menu-icon"
                [attr.boardId]="board.id"
              ></i>
              <dx-context-menu
                [target]="'[boardId=\'' + board.id + '\']'"
                showEvent="click"
                [elementAttr]="{ class: 'gpd-context-menu' }"
                cssClass="gpd-context-menu"
                (onItemClick)="onContextMenuItemClick($event, board)"
              >
                <dxi-item text="Edit" i18n-text="@@edit"></dxi-item>
                <dxi-item text="Delete" i18n-text="@@delete"></dxi-item>
              </dx-context-menu>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="gpd-full-page">
    <router-outlet *ngIf="boardList.length > 0 && boardsLoaded" ></router-outlet>

    <div class="no-board-state" *ngIf="boardList.length === 0 && boardsLoaded">
      <div class="no-board-content">
        <h3 class="no-board-title" i18n="@@noBoardsTitle">No boards</h3>
        <p class="no-board-message" i18n="@@noBoardsMessage">
          Get started by creating a new board for your project. Boards help you
          organize sparks.
        </p>
        <app-gpd-button
          text="Board erstellen"
          i18n-text="@@createBoard"
          icon="add"
          (onClick)="onCreateBoardClick()"
        ></app-gpd-button>
      </div>
    </div>
  </div>
  <app-spark-history-overlay></app-spark-history-overlay>
</div>

<app-generic-popup
  *ngIf="editingBoard"
  [visible]="createBoardPopupVisible"
  i18n-title="@@create-board-title"
  title="What should the board be called?"
  [buttons]="BoardEditButtons"
>
  <dx-text-box
    #boardNameInput
    class="gpd-input"
    [(value)]="editingBoard.name"
    width="100%"
    valueChangeEvent="keyup"
  >
    <dx-validator #boardNameValidator>
      <dxi-validation-rule
        type="required"
        i18n-message="@@required"
        message="Required"
      />
      <dxi-validation-rule
        type="stringLength"
        max="50"
        i18n-message="@@boardNameExceedLength-50"
        message="Board name cannot exceed 50 characters"
      />
      <dxi-validation-rule
        type="custom"
        message="Board name already exists"
        i18n-message="@@boardNameAlreadyExists"
        [validationCallback]="boardNameExists"
      />
    </dx-validator>
  </dx-text-box>
</app-generic-popup>

<!-- Spark History Overlay -->
